module.exports = __webpack_public_path__ + "static/google-play-app-store-download.45425725.png";